module.exports = "/_next/static/images/d9aee5e92f65c1e0bc87047b11f76285-credit-card-prepayment@0.5x.png";